module.exports = __webpack_public_path__ + "img/logo-branco-orizontal.c53d17d6.png";